import Base from './base'

export default class TeamEmailSettings extends Base {
  async show() {
    return this.api.get('team_email_settings.json')
  }
}
